import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Crown, Users, Sparkles } from 'lucide-react';

export function UserBadges({ user, size = 'default', showAll = true }) {
  if (!user) return null;

  const badges = [];

  // Badge Pioneiro (verde) - Todos têm
  if (user.is_pioneer && showAll) {
    badges.push({
      type: 'pioneer',
      label: 'Pioneiro',
      icon: Sparkles,
      className: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white border-0',
      priority: 3
    });
  }

  // Badge Fundador (dourado) - Apenas pagantes
  if (user.is_founder) {
    const founderLabel = user.founder_number 
      ? `Fundador #${user.founder_number}${user.founder_country ? ` (${user.founder_country})` : ''}`
      : 'Fundador';
    
    badges.push({
      type: 'founder',
      label: founderLabel,
      icon: Crown,
      className: 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white border-0 font-bold',
      priority: 1
    });
  }

  // Badge Mentor (roxo/destaque) - Aprovados
  if (user.is_mentor) {
    badges.push({
      type: 'mentor',
      label: 'Mentor',
      icon: Users,
      className: 'bg-gradient-to-r from-purple-500 to-indigo-600 text-white border-0 font-bold',
      priority: 2
    });
  }

  // Ordenar por prioridade (menor número = maior prioridade)
  badges.sort((a, b) => a.priority - b.priority);

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    default: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  };

  return (
    <div className="flex flex-wrap gap-2">
      {badges.map((badge) => {
        const Icon = badge.icon;
        return (
          <Badge
            key={badge.type}
            className={`${badge.className} ${sizeClasses[size]} flex items-center gap-1`}
          >
            <Icon className={`h-3 w-3 ${size === 'lg' ? 'h-4 w-4' : ''}`} />
            {badge.label}
          </Badge>
        );
      })}
    </div>
  );
}
